import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseTypographyComponent } from '../base-typography.component';
@Component({
  selector: 'app-h5',
  template: '<h5 [ngClass]="ngClass" [style.fontSize]="fontSize" [style.lineHeight]="lineHeight"><ng-content></ng-content></h5>',
  styleUrls: ['./h5.component.scss'],
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class H5Component extends BaseTypographyComponent {
  @Input() center?: boolean;
  @Input() inline?: boolean;
  @Input() fontSize?: string;
  @Input() lineHeight?: string;
  @Input() largerFontSize?: boolean;

  override get ngClass(): string[] {
    return [
      this.noMargin !== undefined ? 'no-margin' : '',
      this.center !== undefined ? 'center' : '',
      this.ink,
      this.inline !== undefined ? 'inline' : '',
      this.largerFontSize !== undefined ? 'larger-font-size' : ''
    ];
  }
}
